"use client";

export default function ErrorBoundary({error}: {error: Error}) {
    return <span>{error?.message}</span>
}